/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'

function termsValues(cart) {
  const terms = []

  if (cart.contains_a_membership) {
    terms.push('membership-agreement')
  }
  if (cart.contains_a_membership || cart.contains_a_virtual_visit) {
    terms.push('hipaa-npp')
  }
  return terms
}

function PolicyAgreements({
  cart,
  errors,
  register = () => ({}),
  membershipAgreementUrl,
  hipaaPrivacyTermsUrl,
  checkboxRef = null,
}) {
  const { ref, ...rest } = register('policy_agreements_checkbox', { required: 'Please agree to the terms to continue.' })
  const hipaaLink = (
    <a href={hipaaPrivacyTermsUrl} target="_blank" rel="noreferrer">
      HIPAA Notice of Privacy Practices
    </a>
  )
  return (
    <div className="row mb-3">
      <div className="col-12 mt-4">
        <div className="form-check">
          <input
            id="policy-agreements"
            type="checkbox"
            className={`form-check-input ${errors.policy_agreements_checkbox ? 'error' : ''}`}
            ref={checkboxRef || ref}
            {...rest}
          />
          <input
            type="hidden"
            name="policy_agreements"
            value={JSON.stringify(termsValues(cart))}
            {...register('policy_agreements')}
          />
          <label htmlFor="policy-agreements" className="form-check-label">
            I agree to the&nbsp;
            {cart.contains_a_membership && (
              <>
                <a href={membershipAgreementUrl} target="_blank" rel="noreferrer">
                  Root Membership Terms of Service & Membership Agreement
                </a>
                {', and the '}
              </>
            )}
            {(cart.contains_a_membership || cart.contains_a_virtual_visit) && (
              <>
                {hipaaLink}
                .
              </>
            )}
          </label>
          {errors.policy_agreements_checkbox && (
            <span className="text-danger">{errors.policy_agreements_checkbox.message}</span>
          )}
        </div>
      </div>
    </div>
  )
}

export default PolicyAgreements
export { termsValues }
